import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '~/b4b/components/error-boundary/ErrorBoundary';
import ScrollToTopOnPathChange from '~/b4b/components/ScrollToTopOnPathChange';
import { useToastCookie } from '~/b4b/features/notifications/useToastCookie';

export const Root = () => {
  useToastCookie();

  return (
    <ErrorBoundary name="root" fallbackType="full">
      <ScrollToTopOnPathChange />
      <Outlet />
    </ErrorBoundary>
  );
};
